import { render, staticRenderFns } from "./TestList.vue?vue&type=template&id=432a0c1c&scoped=true"
import script from "./TestList.vue?vue&type=script&lang=js"
export * from "./TestList.vue?vue&type=script&lang=js"
import style0 from "./TestList.vue?vue&type=style&index=0&id=432a0c1c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "432a0c1c",
  null
  
)

export default component.exports